import axios from 'axios';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface MyStatus {
  readonly requiresEmployeeRecord: boolean;
  readonly subsystemAccess: Record<string, boolean>;
}

export async function fetchMyStatus(signal?: AbortSignal): Promise<MyStatus> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.get<{
    requiresEmployeeRecord: boolean;
    subsystemAccess?: Record<string, boolean>;
  }>(`${config.baseURL}/greenfield/app/me`, config);

  return {
    requiresEmployeeRecord: response.data.requiresEmployeeRecord,
    subsystemAccess: response.data.subsystemAccess ?? {},
  };
}
